import { CardMedia, Stack, Typography, useTheme } from '@mui/material';

import { Strings } from '@app/constants';
import useResponsive from '@app/hooks/use-responsive';

const IngredientsTab = ({ data }: any) => {
  const theme = useTheme();
  const isMobile = useResponsive('down', 'sm');

  return (
    <Stack m={4}>
      <Typography color={theme.palette.tertiary.shadyText} sx={styles.description}>
        {Strings.common.ingredientsNotes}
      </Typography>
      {data.map((item: any, index: any) => {
        return (
          <Stack
            key={index}
            sx={[styles.ingredientContainer, { width: isMobile ? '100%' : '50%' }]}
          >
            <Stack sx={styles.ingredientNameContainer}>
              <CardMedia component="img" image={item?.image} sx={{ height: 25, width: 25 }} />
              <Typography variant="subtitle2" ml={1}>
                {item.food}
              </Typography>
            </Stack>
            <Typography variant="caption">
              {item.quantity}{' '}
              {item?.measure && item?.measure?.includes('unit')
                ? 'pcs'
                : item?.measure?.includes('tablespoon')
                  ? 'tbsp'
                  : item?.measure?.includes('teaspoon')
                    ? 'tsp'
                    : item?.measure}
            </Typography>
          </Stack>
        );
      })}
    </Stack>
  );
};

const styles = {
  description: {
    letterSpacing: 0.5,
    fontSize: 13,
    marginY: 2,
  },
  ingredientContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  ingredientNameContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '80%',
    marginY: 1,
  },
  ingredientImageStyles: {
    height: '24px',
    width: '24px',
    marginRight: '20px',
  },
};

export { IngredientsTab };
